module.exports = __webpack_public_path__ + "img/halfclosed_black_blurred.7f9e7b16.png";